import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import VHome from '@/views/VHome/VHome.vue'
import VApiExplorer from '@/views/VApiExplorer/VApiExplorer.vue'
import VMainLayout from '@/views/VMainLayout/VMainLayout.vue'
import VNotFound from '@/views/VNotFound/VNotFound.vue'
import VCatalog from '@/views/VCatalog/VCatalog.vue'
Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    component: VMainLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: VApiExplorer
      },
      {
        path: '*',
        name: 'not-found',
        component: VNotFound
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
